import { PlaidLinkDirective } from '@components/plaid-link/plaid-link.directive';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { NgModule } from '@angular/core';
import { ElementsModule } from '@shared/elements/elements.module';

@NgModule({
    imports: [
        CommonModule,
        ElementsModule,
        TranslateModule
    ],
    exports: [PlaidLinkDirective],
    declarations: [PlaidLinkDirective],
    providers: [],
})
export class PlaidLinkModule {}
